package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminNotificationSettingsResponse(
    val groups: List<AdminNotificationGroup>,
    @SerialName("display_items") val displayItems: List<AdminNotificationDisplayItem>,
    @SerialName("event_types") val eventTypes: List<AdminNotificationEventType>
)

@Serializable
data class AdminNotificationGroup(
    val code: String,
    @SerialName("name_ar") val nameAr: String,
    @SerialName("name_en") val nameEn: String,
    @SerialName("description_ar") val descriptionAr: String? = null,
    @SerialName("description_en") val descriptionEn: String? = null,
    @SerialName("sort_order") val sortOrder: Int = 0,
    @SerialName("default_enabled") val defaultEnabled: Boolean = true,
    val active: Boolean = true
)

@Serializable
data class AdminNotificationDisplayItem(
    val code: String,
    @SerialName("group_code") val groupCode: String,
    @SerialName("name_ar") val nameAr: String,
    @SerialName("name_en") val nameEn: String,
    @SerialName("description_ar") val descriptionAr: String? = null,
    @SerialName("description_en") val descriptionEn: String? = null,
    @SerialName("sort_order") val sortOrder: Int = 0,
    val active: Boolean = true
)

@Serializable
data class AdminNotificationEventType(
    val code: String,
    @SerialName("group_code") val groupCode: String? = null,
    @SerialName("display_item_code") val displayItemCode: String? = null,
    @SerialName("name_ar") val nameAr: String? = null,
    @SerialName("name_en") val nameEn: String? = null,
    @SerialName("title_template_ar") val titleTemplateAr: String? = null,
    @SerialName("title_template_en") val titleTemplateEn: String? = null,
    @SerialName("body_template_ar") val bodyTemplateAr: String? = null,
    @SerialName("body_template_en") val bodyTemplateEn: String? = null,
    @SerialName("has_image") val hasImage: Boolean = false,
    val enabled: Boolean = false,
    @SerialName("ttl_seconds") val ttlSeconds: Int = 900,
    /** mapped | unmapped; set by the server. */
    val status: String = "unmapped",
    @SerialName("first_seen_at_utc") val firstSeenAtUtc: String? = null,
    @SerialName("last_seen_at_utc") val lastSeenAtUtc: String? = null
)

@Serializable
data class AdminTemplatePreviewRequest(
    @SerialName("title_template_ar") val titleTemplateAr: String? = null,
    @SerialName("title_template_en") val titleTemplateEn: String? = null,
    @SerialName("body_template_ar") val bodyTemplateAr: String? = null,
    @SerialName("body_template_en") val bodyTemplateEn: String? = null,
    val values: Map<String, String> = emptyMap()
)

@Serializable
data class AdminTemplatePreviewResponse(
    @SerialName("title_ar") val titleAr: String? = null,
    @SerialName("title_en") val titleEn: String? = null,
    @SerialName("body_ar") val bodyAr: String? = null,
    @SerialName("body_en") val bodyEn: String? = null,
    /** Placeholders with neither a value nor a default. */
    val missing: List<String> = emptyList(),
    val placeholders: List<String> = emptyList()
)
